import { ILoaderState, ISetLoaderAction } from "./types";
import ActionTypes from '../../../constants/ActionTypes';
import { isWebView } from "../../../config/config";

const initialState: ILoaderState = {
  loading: false,
  error: false,
  entity: '',
  webview: isWebView()
};

const uiReducer = (store = initialState, action: ISetLoaderAction): ILoaderState  => {
  switch (action.type) {
  case ActionTypes.SET_LOADER:
    return {
      ...store,
      loading: action.payload,
      entity: action.meta.entity,
    };
  case ActionTypes.SET_ERROR:
    return {
      ...store,
      error: action.payload,
      entity: action.meta.entity,
    };
  default:
    break;
  }
  return store;
};

export default uiReducer;
